export const ELECTRON_KEYCLOAK_REDIRECT_URI = 'https://localhost:3000/login'

const CALLBACK_STORAGE_PREFIX = 'kc-callback-'

export function isKeycloakCallbackUrl(targetUrl: string, redirectUri: string) {
    try {
        const target = new URL(targetUrl)
        const redirect = new URL(redirectUri)
        return target.origin === redirect.origin && target.pathname === redirect.pathname
    } catch {
        return false
    }
}

export type StoredKeycloakCallback = {
    pkceCodeVerifier?: string
    redirectUri?: string
    nonce?: string
}

export function takeStoredKeycloakCallback(state: string): StoredKeycloakCallback | undefined {
    const key = CALLBACK_STORAGE_PREFIX + state
    const raw = localStorage.getItem(key)
    if (!raw) return
    localStorage.removeItem(key)
    return JSON.parse(raw) as StoredKeycloakCallback
}
